import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';
import {
  isCalendarDateAfter,
  isCalendarDateOnOrAfter,
  isCalendarDateOnOrBefore,
  serializeDateForApi
} from '../dates/dateService';

export {
  ApiResponseError as PeriodosApiError,
  ApiSessionTimeoutError as PeriodosSessionTimeoutError,
  classifyApiError as classifyPeriodosError,
  unwrapResponseModel
};

export function toCreatePeriodoCursadaPayload({
  descripcion,
  fechaInicio,
  fechaFin,
  inicioInscripcion,
  finInscripcion,
  anioAcademicoCod
}) {
  return {
    PeriodoCursadaDescripcion: descripcion,
    PeriodoCursadaFechaInicio: serializeDateForApi(fechaInicio),
    PeriodoCursadaFechaFin: serializeDateForApi(fechaFin),
    PeriodoCursadaInicioInscripcio: serializeDateForApi(inicioInscripcion),
    PeriodoCursadaFinInscripcion: serializeDateForApi(finInscripcion),
    AnioAcademicoCod: anioAcademicoCod
  };
}

export function toUpdatePeriodoCursadaPayload({
  id,
  descripcion,
  fechaInicio,
  fechaFin,
  inicioInscripcion,
  finInscripcion,
  anioAcademicoCod
}) {
  return {
    PeriodoCursadaCod: id,
    PeriodoCursadaDescripcion: descripcion,
    PeriodoCursadaFechaInicio: serializeDateForApi(fechaInicio),
    PeriodoCursadaFechaFin: serializeDateForApi(fechaFin),
    PeriodoCursadaInicioInscripcio: serializeDateForApi(inicioInscripcion),
    PeriodoCursadaFinInscripcion: serializeDateForApi(finInscripcion),
    AnioAcademicoCod: anioAcademicoCod
  };
}

export function toCreatePeriodoExamenPayload({
  descripcion,
  llamado,
  fechaInicio,
  fechaFin,
  anioAcademicoCod
}) {
  return {
    PeriodoExamenDescripcion: descripcion,
    PeriodoExamenLlamado: llamado,
    PeriodoExamenFechaInicio: serializeDateForApi(fechaInicio),
    PeriodoExamenFechaFin: serializeDateForApi(fechaFin),
    AnioAcademicoCod: anioAcademicoCod
  };
}

export function toUpdatePeriodoExamenPayload({
  id,
  descripcion,
  llamado,
  fechaInicio,
  fechaFin,
  anioAcademicoCod
}) {
  return {
    PeridoExamenCod: id,
    PeriodoExamenDescripcion: descripcion,
    PeriodoExamenLlamado: llamado,
    PeriodoExamenFechaInicio: serializeDateForApi(fechaInicio),
    PeriodoExamenFechaFin: serializeDateForApi(fechaFin),
    AnioAcademicoCod: anioAcademicoCod
  };
}

export function validatePeriodoCursadaFormAdd(fields) {
  return Boolean(
    fields.descripcion?.length > 0
    && fields.anioDescripcion?.length > 1
    && fields.startDate != null
    && fields.endDate != null
    && fields.startInscriptionDate != null
    && fields.endInscriptionDate != null
  );
}

export function validatePeriodoCursadaFormUpdate(fields) {
  return Boolean(
    fields.descripcion?.length > 0
    && fields.anioPresent
    && fields.anioDescripcion?.length > 0
    && fields.startDate != null
    && fields.endDate != null
    && fields.startInscriptionDate != null
    && fields.endInscriptionDate != null
  );
}

export function validatePeriodoExamenFormAdd(fields) {
  return Boolean(
    fields.descripcion?.length > 0
    && fields.llamado?.length > 0
    && fields.anioDescripcion?.length > 1
    && fields.startDate != null
    && fields.endDate != null
  );
}

export function validatePeriodoExamenFormUpdate(fields) {
  return Boolean(
    fields.descripcion?.length > 0
    && fields.llamado?.length > 0
    && fields.anioPresent
    && fields.anioDescripcion?.length > 0
    && fields.startDate != null
    && fields.endDate != null
  );
}

export function validatePeriodDates(startDate, endDate) {
  return isCalendarDateAfter(endDate, startDate);
}

export function validateInscriptionDates(startInscriptionDate, endInscriptionDate) {
  return isCalendarDateAfter(endInscriptionDate, startInscriptionDate);
}

export function validateInscriptionInsidePeriod({
  startDate,
  endDate,
  startInscriptionDate,
  endInscriptionDate
}) {
  return (
    isCalendarDateOnOrAfter(endDate, startInscriptionDate)
    && isCalendarDateOnOrAfter(startInscriptionDate, startDate)
    && isCalendarDateOnOrAfter(endDate, endInscriptionDate)
    && isCalendarDateOnOrAfter(endInscriptionDate, startDate)
  );
}

export const PERIODO_CURSADA_OPTIONS = [
  { value: 'A', label: 'Anual' },
  { value: '1', label: 'Primer Cuatrimestre' },
  { value: '2', label: 'Segundo Cuatrimestre' },
];

export function getPeriodoCursadaLabel(periodoCursadaDescripcion) {
  const value = String(periodoCursadaDescripcion ?? '').trim();
  if (value === '1') {
    return 'Primer Cuatrimestre';
  }
  if (value === '2') {
    return 'Segundo Cuatrimestre';
  }
  return 'Anual';
}

export function buildPeriodoExamenValidationError({ formValid, datesOk }) {
  if (!formValid && !datesOk) {
    return 'Todos los campos son obligatorios, la fecha de inicio no puede ser posterior a la fecha de fin';
  }
  if (!formValid) {
    return 'Todos los campos son obligatorios';
  }
  if (!datesOk) {
    return 'La fecha de inicio no puede ser posterior a la fecha de fin';
  }
  return '';
}

export function buildPeriodoCursadaValidationError({
  formValid,
  datesOk,
  inscriptionDatesOk,
  inscriptionInsidePeriod,
}) {
  const messages = [];
  if (!formValid) {
    messages.push('Todos los campos son obligatorios');
  }
  if (!datesOk) {
    messages.push('la fecha de inicio no puede ser posterior a la fecha de fin');
  }
  if (!inscriptionDatesOk) {
    messages.push('la fecha de inicio de inscripción no puede ser posterior a la fecha de fin');
  }
  if (!inscriptionInsidePeriod) {
    messages.push('las fechas de inscripción deben estar dentro del rango de fechas ingresado para el período de cursada');
  }
  if (messages.length === 0) {
    return '';
  }
  if (messages.length === 1 && messages[0] === 'Todos los campos son obligatorios') {
    return messages[0];
  }
  return messages.join(', ');
}
